import { IWebsiteBuilderEditorHistoryActionBase, IWebsiteBuilderHistorySnapshot, WebsiteBuilderEditorActionType } from "../../websiteBuilderEditorAction";
import { cloneDeep } from "lodash";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { elementTraversal } from "../../actionHelpers/elementTraversal";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { IWebsiteBuilderSectionEntityStretch } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderSectionEntity";

export interface IUpdateElementStretchActionPayload {
  id: string;
  prevStretch: IWebsiteBuilderSectionEntityStretch;
  nextStretch: IWebsiteBuilderSectionEntityStretch;
}

export interface IUpdateElementStretchAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.UPDATE_ELEMENT_STRETCH;
  payload: IUpdateElementStretchActionPayload;
}

export function getUpdateElementStretchInverseAction(action: IUpdateElementStretchAction): IUpdateElementStretchAction {
  const { id, nextStretch, prevStretch } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.UPDATE_ELEMENT_STRETCH,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: action.scrollNodeId,
    payload: {
      id,
      prevStretch: cloneDeep(nextStretch),
      nextStretch: cloneDeep(prevStretch),
    },
  };
}

export function applyUpdateElementStretchChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: IUpdateElementStretchAction,
): IWebsiteBuilderHistorySnapshot {
  const { id, nextStretch } = action.payload;

  return elementTraversal(header, root, footer, id, {
    stretch: cloneDeep(nextStretch),
  });
}
